/**
 *  ----------------------------------------------------------------
 *  Copyright © Backbase B.V.
 *  ----------------------------------------------------------------
 *  Author : Backbase R&D - Amsterdam - New York
 *  Filename : main.js
 *  Description:
 *  Main File Module Sample
 *  ----------------------------------------------------------------
 */

define(function (require, exports, module) {

    'use strict';

    module.name = 'module-common-abc';

    var base = require('base');
    var autoGrow = require('./directives/auto-grow');
    var fileSelector = require('./directives/file-selector');
    var onlyNumbers = require('./directives/only-numbers');
    var uuid = require('./lib/uuid');
    var downloadFile = require('./lib/download-file');
    var tmxProfilerService = require('./tmxProfilerService');


    //var constants = require('./constants');

    var deps = [];

    module.exports = base.createModule(module.name, deps)
        .constant(require('./constants'))
        .factory('uuid', [uuid])
        .factory('downloadFile', [downloadFile])
        .factory('tmxProfilerService',[tmxProfilerService])
        .directive('autoGrow', ['$window', autoGrow])
        .directive('fileSelector', ['uuid', '$timeout', fileSelector])
        .directive('onlyNumbers', onlyNumbers);
    //.service(require('abcCommonServices'));
});



//////////////////
// WEBPACK FOOTER
// ./scripts/main.js
// module id = 1
// module chunks = 0